import { render } from "./CorsiCatalogoView.vue?vue&type=template&id=77e2581a"
import script from "./CorsiCatalogoView.vue?vue&type=script&lang=js"
export * from "./CorsiCatalogoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__